<template>
  <el-dialog 
    title="修改数量" 
    :visible.sync="dialogVisible" 
    width="400px" 
    append-to-body
    @close="handleClose" 
    @opened="handleOpened"
  >
    <!-- 商品信息展示 -->
    <div 
      v-if="selectedCartItem"
      style="margin-bottom: 15px; padding: 10px; background: #f0f9ff; border-radius: 4px; border-left: 4px solid #409EFF;"
    >
      <div style="color: #409EFF; font-weight: bold; margin-bottom: 5px;">商品信息：</div>
      <div style="color: #666; font-size: 14px;">
        {{ selectedCartItem.bgmName }} - {{ selectedCartItem.spec }}
      </div>
      <div style="color: #666; font-size: 14px;">
        当前数量：{{ selectedCartItem.quantity }}
      </div>
      <!-- 专管/含麻商品限制提示 -->
      <div
        v-if="isSpecialProduct"
        style="color: #e6a23c; font-size: 13px; margin-top: 8px; padding: 6px 8px; background: rgba(230, 162, 60, 0.1); border-radius: 4px; border-left: 3px solid #e6a23c;"
      >
        <i class="el-icon-warning"></i>
        <span>专管/含麻类商品单次购买总数量不能超过2盒</span>
      </div>
    </div>

    <!-- 数量编辑表单 -->
    <el-form 
      id="quantityEditForm" 
      :model="form" 
      :rules="rules" 
      ref="quantityEditFormRef"
      label-width="80px" 
      size="small" 
      @submit.native.prevent
    >
      <el-form-item label="数量" prop="quantity">
        <el-input 
          ref="quantityEditInput" 
          v-model="form.quantity" 
          :min="1" 
          type="number"
          style="width: 100%" 
          @keydown.enter.native.prevent="handleConfirm" 
        />
      </el-form-item>
    </el-form>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'QuantityEditDialog',
  props: {
    // 弹窗显示状态
    visible: {
      type: Boolean,
      default: false
    },
    // 选中的购物车商品
    selectedCartItem: {
      type: Object,
      default: () => null
    },
    // 购物车商品列表
    cartItems: {
      type: Array,
      default: () => []
    },
    // 选中商品的索引
    selectedItemIndex: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      // 表单数据
      form: {
        quantity: 1
      }
    };
  },
  computed: {
    // 弹窗显示状态的双向绑定
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    
    // 是否为专管/含麻商品
    isSpecialProduct() {
      return this.selectedCartItem && 
             this.selectedCartItem.bgiType && 
             (this.selectedCartItem.bgiType.includes('含麻') || 
              this.selectedCartItem.bgiType.includes('专管'));
    },
    
    // 表单验证规则
    rules() {
      return {
        quantity: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = parseFloat(value);
              if (isNaN(num) || num < 1) {
                callback(new Error('数量不能小于1'));
                return;
              }

              // 检查是否为专管或含麻商品
              if (this.isSpecialProduct) {
                // 计算其他专管/含麻商品的数量（不包括当前商品）
                const otherSpecialTotal = this.cartItems
                  .filter((item, index) =>
                    index !== this.selectedItemIndex &&
                    item.bgiType &&
                    (item.bgiType.includes('含麻') || item.bgiType.includes('专管'))
                  )
                  .reduce((sum, item) => sum + (item.quantity || 0), 0);

                // 检查总数量是否超过限制
                const totalSpecialQuantity = otherSpecialTotal + num;
                if (totalSpecialQuantity > 2) {
                  callback(new Error(`专管/含麻类商品总数量不能超过2盒，当前其他商品已占用${otherSpecialTotal}盒，最多只能设置${2 - otherSpecialTotal}盒`));
                  return;
                }
              }

              callback();
            },
            trigger: 'blur'
          }
        ]
      };
    }
  },
  watch: {
    // 监听选中商品变化，更新表单数据
    selectedCartItem: {
      handler(newItem) {
        if (newItem) {
          this.form.quantity = newItem.quantity;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 弹窗打开事件
    handleOpened() {
      this.$nextTick(() => {
        // 聚焦到数量输入框
        if (this.$refs.quantityEditInput) {
          this.$refs.quantityEditInput.focus();
          this.$refs.quantityEditInput.select(); // 全选输入框内容
        }
      });
      this.$emit('opened');
    },

    // 弹窗关闭事件
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },

    // 确认修改
    handleConfirm() {
      this.$refs.quantityEditFormRef.validate((valid) => {
        if (!valid) return;
        
        const quantity = parseFloat(this.form.quantity);
        this.$emit('confirm', { quantity });
      });
    }
  }
};
</script>

<style scoped>
/* 表单标签颜色 */
::v-deep #quantityEditForm .el-form-item__label {
  color: #606266 !important;
}
</style>
